import { NavLink, useNavigate } from "react-router-dom";
import { House, ChartLineUp, BookOpen, Gear, Plus } from "@phosphor-icons/react";

const items = [
  { to: "/dashboard", label: "Home", icon: House, testid: "mobile-nav-dashboard" },
  { to: "/assessments", label: "Dossiers", icon: ChartLineUp, testid: "mobile-nav-assessments" },
  { to: "/knowledge", label: "Vault", icon: BookOpen, testid: "mobile-nav-knowledge" },
  { to: "/settings", label: "Workspace", icon: Gear, testid: "mobile-nav-settings" },
];

export default function MobileBottomNav() {
  const navigate = useNavigate();
  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-card border-t border-border pb-safe"
      data-testid="mobile-bottom-nav"
    >
      <div className="relative grid grid-cols-5 h-16">
        {items.slice(0, 2).map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            data-testid={it.testid}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 text-[11px] transition-colors ${
                isActive ? "text-primary font-semibold" : "text-muted-foreground"
              }`
            }
          >
            <it.icon size={20} weight="regular" />
            {it.label}
          </NavLink>
        ))}

        {/* Center FAB */}
        <div className="flex items-center justify-center">
          <button
            onClick={() => navigate("/assessments/new")}
            className="absolute -top-5 h-12 w-12 rounded-full bg-primary text-primary-foreground grid place-items-center card-elev-lg active:scale-95 transition-transform"
            data-testid="mobile-nav-new"
            aria-label="New assessment"
          >
            <Plus size={20} weight="bold" />
          </button>
        </div>

        {items.slice(2).map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            data-testid={it.testid}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 text-[11px] transition-colors ${
                isActive ? "text-primary font-semibold" : "text-muted-foreground"
              }`
            }
          >
            <it.icon size={20} weight="regular" />
            {it.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
